import { GET_CATEGORY } from "../Action/type";

const initialState = {
  categoryList: [],
  count: 0,
};
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_CATEGORY:
      return {
        ...state,
        categoryList: payload?.categories,
        count: payload?.count,
      };

    default:
      return state;
  }
}
